import { Box, Heading, Text, Flex, Badge } from "@chakra-ui/react";
import { Link as ChakraLink } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { Evento } from "../../services/models/Evento";

interface EventoPrincipalProps {
  evento: Evento;
}

const EventoPrincipal = ({ evento }: EventoPrincipalProps) => {
  return (
    <ChakraLink as={RouterLink} to={`/eventos/${evento.id}`} _hover={{ textDecoration: "none" }}>
      <Box
        w="100%"
        bg="rgba(120, 165, 255, 0.9)"
        borderRadius="xl"
        boxShadow="0px 6px 20px rgba(0,0,0,0.3)"
        p={6}
        mb={6}
        transition="0.3s"
        _hover={{
          transform: "scale(1.02)",
          boxShadow: "0px 8px 25px rgba(0,0,0,0.4)",
        }}
      >
        <Flex direction={{ base: "column", md: "row" }} justify="space-between" align="start">
          {/* Contenido principal */}
          <Box flex="1" mr={{ base: 0, md: 6 }} mb={{ base: 4, md: 0 }}>
            <Heading size="lg" color="black" mb={3}>
              {evento.titulo}
            </Heading>

            {evento.institucion_nombre && (
              <Flex align="center" mb={2}>
                <Badge colorScheme="blue" mr={2}>
                  Institución
                </Badge>
                <Text fontWeight="semibold" color="black">
                  {evento.institucion_nombre}
                </Text>
              </Flex>
            )}

            {evento.organizador_nombre && (
              <Flex align="center" mb={2}>
                <Badge colorScheme="green" mr={2}>
                  Fechas
                </Badge>
                <Text color="black">{evento.inicio ? new Date(evento.inicio).toLocaleDateString("es-ES") : "Por confirmar"} - {evento.fin ? new Date(evento.fin).toLocaleDateString("es-ES") : "Por confirmar"}</Text>
              </Flex>
            )}

            {evento.ubicacion && (
              <Flex align="center" mb={2}>
                <Badge colorScheme="purple" mr={2}>
                  📍 Ubicación
                </Badge>
                <Text color="black">{evento.ubicacion}</Text>
              </Flex>
            )}

            <Text fontSize="sm" color="gray.700" mt={3}>
              Publicado: {new Date(evento.creado_en).toLocaleDateString("es-ES", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </Text>
          </Box>

          {/* Estadísticas */}
          <Flex
            direction="column"
            align={{ base: "start", md: "end" }}
            minW={{ base: "100%", md: "200px" }}
          >
            {(evento.contLikes !== undefined || evento.contDislikes !== undefined) && (
              <Box mb={3}>
                <Flex gap={4}>
                  <Flex align="center" gap={1}>
                    <Text fontSize="2xl">👍</Text>
                    <Text fontWeight="bold" fontSize="xl" color="green.600">
                      {evento.contLikes || 0}
                    </Text>
                  </Flex>
                  <Flex align="center" gap={1}>
                    <Text fontSize="2xl">👎</Text>
                    <Text fontWeight="bold" fontSize="xl" color="red.600">
                      {evento.contDislikes || 0}
                    </Text>
                  </Flex>
                </Flex>
              </Box>
            )}

            {evento.ContParticipantesPosibles !== undefined &&
              evento.ContParticipantesPosibles > 0 && (
                <Box
                  bg="rgba(2, 54, 176, 0.9)"
                  color="white"
                  px={4}
                  py={2}
                  borderRadius="md"
                  textAlign="center"
                >
                  <Text fontSize="sm" fontWeight="semibold">
                    Participantes
                  </Text>
                  <Text fontSize="2xl" fontWeight="bold">
                    {evento.ContParticipantesPosibles}
                  </Text>
                </Box>
              )}
          </Flex>
        </Flex>
      </Box>
    </ChakraLink>
  );
};

export default EventoPrincipal;
